/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { HandThumbDownIcon16Light } from './HandThumbDownIcon16Light';
import { HandThumbDownIcon16Regular } from './HandThumbDownIcon16Regular';
import { HandThumbDownIcon16Solid } from './HandThumbDownIcon16Solid';
import { HandThumbDownIcon20Light } from './HandThumbDownIcon20Light';
import { HandThumbDownIcon20Regular } from './HandThumbDownIcon20Regular';
import { HandThumbDownIcon20Solid } from './HandThumbDownIcon20Solid';
import { HandThumbDownIcon24Regular } from './HandThumbDownIcon24Regular';
import { HandThumbDownIcon24Solid } from './HandThumbDownIcon24Solid';
import { HandThumbDownIcon32Regular } from './HandThumbDownIcon32Regular';
import { HandThumbDownIcon64Regular } from './HandThumbDownIcon64Regular';
var sizes = {
    16: {
        light: HandThumbDownIcon16Light,
        regular: HandThumbDownIcon16Regular,
        solid: HandThumbDownIcon16Solid,
    },
    20: {
        light: HandThumbDownIcon20Light,
        regular: HandThumbDownIcon20Regular,
        solid: HandThumbDownIcon20Solid,
    },
    24: {
        regular: HandThumbDownIcon24Regular,
        solid: HandThumbDownIcon24Solid,
    },
    32: {
        regular: HandThumbDownIcon32Regular,
    },
    64: {
        regular: HandThumbDownIcon64Regular,
    },
};
export var HandThumbDownIcon = forwardRef('HandThumbDownIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
